import React from 'react'
import From from './From'
import { Heading, Center } from "@chakra-ui/react";


export const Contact = () => {
  return (
      <div className="pt-3" id='contact'>
        <Center className='pt-5'>
          <Heading >
          Take A<span style={{ color: "rgb(220, 20, 60)" }}> Coffee </span>And
          <span style={{ color: "rgb(220, 20, 60)" }}> Chat </span>With Me
          </Heading>
        </Center>

        <From/>
  </div>

  )
}
